var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81098 20.0195C6.38171 20.0195 6.0141 19.8665 5.70815 19.5606C5.40272 19.2552 5.25 18.8878 5.25 18.4585V7.53171C5.25 7.10244 5.40272 6.73483 5.70815 6.42888C6.0141 6.12345 6.38171 5.97073 6.81098 5.97073H13.7768L12.2159 7.53171H6.81098V18.4585H17.7378V13.0341L19.2988 11.4732V18.4585C19.2988 18.8878 19.1461 19.2552 18.8406 19.5606C18.5347 19.8665 18.1671 20.0195 17.7378 20.0195H6.81098ZM15.5329 6.41951L16.6451 7.5122L11.4939 12.6634V13.7756H12.5866L17.7573 8.60488L18.8695 9.69756L13.25 15.3366H9.93293V12.0195L15.5329 6.41951ZM18.8695 9.69756L15.5329 6.41951L17.4841 4.46829C17.7963 4.1561 18.1705 4 18.6065 4C19.042 4 19.4093 4.1561 19.7085 4.46829L20.8012 5.58049C21.1004 5.87967 21.25 6.2439 21.25 6.67317C21.25 7.10244 21.1004 7.46667 20.8012 7.76585L18.8695 9.69756Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.8602b4ff2ca69fc5ccf8114a46bc0cd5.svg";
export { ForwardRef as ReactComponent };